import type {ReactElement} from 'react';
import React, {useState} from 'react';
import type {ChatHistoryListItemThumbProps} from './chat-history-list-item-thumb.types';
import styles from './chat-history-list-item-thumb.module.scss';
import {Icon} from '@Components/icon-v2';
import {IconSize} from '@Components/icon-v2/icon.types';
import {useIsInViewport} from '@/hooks/useIsInViewport';
import {SkeletonBrickTheme} from '@Components/skeleton-brick';
import {MediaItemSizeType} from '@Libraries/s3-library';
import {getUrlForGeneratedAiChatModelAssetsImage} from '@Libraries/ai-chat.library';
import {ThumbnailType} from '@Components/thumbnail/thumbnail.types';
import {ImageThumbnail} from '@Components/thumbnail/components/image-thumbnail/image-thumbnail';

export function ChatHistoryListItemThumb({...props}: ChatHistoryListItemThumbProps): ReactElement {
  const [thumbRef, setThumbRef] = useState<HTMLDivElement | null>(null);
  const isInViewport = useIsInViewport(thumbRef as HTMLElement);

  const getChatHistoryListItemThumb = (): ReactElement => {
    if (props.historyItem.assetHashedFilename && isInViewport) {
      return (
        <div ref={setThumbRef} className={`radius-8 ${styles.sidebarThumbContainer}`}>
          <ImageThumbnail
            data={{
              type: ThumbnailType.IMAGE,
              showSkeletonLoading: true,
              skeletonLoadingTheme: SkeletonBrickTheme.LIGHT_TWO,
              imageSrc: getUrlForGeneratedAiChatModelAssetsImage(props.historyItem.assetHashedFilename, MediaItemSizeType.THUMB),
              imageClassName: styles.sidebarThumbImage,
            }}
            className={`radius-8 ${styles.sidebarThumbContainer}`}
          />
        </div>
      );
    }

    return (
      <div ref={setThumbRef} className={`radius-8 ${styles.sidebarThumbContainer} flex-row-align-center flex-row-justify-center`}>
        <Icon icon="icon-doc" className="content-disabled" size={IconSize.SIZE_ICON_24} />
      </div>
    );
  };

  return getChatHistoryListItemThumb();
}
